import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section, Heading, Eyebrow } from '../Section';
import { SectionCTA } from '../SectionCTA';
export function Guarantee() {
  return <Section tone="white" data-id="element-179" data-mp="24ngim7yxfi7y">
      <Eyebrow data-id="element-180" data-mp="24m5e25xnq6fs">Tu compra está completamente protegida</Eyebrow>
      <Heading data-id="element-181" data-mp="29doj606mjyj4">
        Garantía Incondicional de <span className="italic text-brand" data-id="element-182" data-mp="29eq5x1x069go">7 Días</span>
      </Heading>

      <div className="mt-7 rounded-3xl border-2 border-good/25 bg-good/[0.05] p-5 sm:p-7" data-id="element-183" data-mp="2edjd6clp548e">
        <div className="flex justify-center" data-id="element-184" data-mp="2jbl4fkta09uy">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-good/10 ring-2 ring-good/25" data-id="element-185" data-mp="2jajj8nijq6zi">
            <ShieldCheckIcon className="h-8 w-8 text-good" aria-hidden="true" data-id="element-186" data-mp="2o9322f1uf2nn" />
          </span>
        </div>

        <div className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-187" data-mp="2sag7wp4xr5uk">
          {['Pruébalo.', 'Revísalo.', 'Utilízalo en tus consultas.'].map(item => <span key={item} className="rounded-full bg-white px-3 py-1.5 text-[12.5px] font-bold text-navy" data-id="element-188" data-mp="xzjef4yl7kmq">
              {item}
            </span>)}
        </div>

        <p className="mx-auto mt-5 max-w-lg text-center text-[14.5px] leading-relaxed text-navy/75 sm:text-base" data-id="element-189" data-mp="3ntf1250h64dn">
          Si en los próximos siete días sientes que el Sistema de Decisión Clínica no te ayuda a tomar
          decisiones con mayor claridad o no aporta valor a tu práctica diaria, simplemente escríbenos
          y te devolveremos el{' '}
          <strong className="font-extrabold text-navy" data-id="element-190" data-mp="afk2n8kgezmp">100% de tu dinero</strong>.
        </p>

        <div className="mx-auto mt-5 grid max-w-sm gap-2" data-id="element-191" data-mp="5g7f0llrdoj2">
          {['Sin formularios complicados.', 'Sin preguntas incómodas.'].map(item => <p key={item} className="rounded-xl bg-white px-3.5 py-2.5 text-center text-[13.5px] font-semibold text-navy/75" data-id="element-192" data-mp="he490xuwbml">
              {item}
            </p>)}
        </div>

        <p className="mt-5 text-center font-serif text-lg font-extrabold italic text-good sm:text-2xl" data-id="element-193" data-mp="1d8fsga27k8uz">
          El riesgo es completamente nuestro.
        </p>
      </div>

      <SectionCTA promise="Decide hoy sin riesgo: o te cambia la consulta, o te devolvemos todo." label="Quiero probarlo sin riesgo" data-id="element-194" data-mp="1h7x09a53xi3b" />
    </Section>;
}